import { gql } from '@apollo/client';

const metricScoreFields = `
    fragment DailyMeetingMetricScoreFields on DailyMeetingMetricScoreType {
        metric
        actual
        target
        gap
        sev
        consecutiveDays
        burst
        contribution
    }
`;

export const QUERY_DAILY_MEETING_SCORE_THRESHOLD = gql`
    query QueryDailyMeetingScoreThreshold {
        queryDailyMeetingScoreThreshold {
            red
            yellow
        }
    }
`;

export const QUERY_DAILY_MEETING_RANKING = gql`
    ${metricScoreFields}
    query QueryDailyMeetingRanking($statDate: String!, $hubId: Long!) {
        queryDailyMeetingRanking(statDate: $statDate, hubId: $hubId) {
            hubId
            hubName
            warehouseId
            warehouseName
            statDate
            actualArrivals
            totalScore
            light
            metrics {
                ...DailyMeetingMetricScoreFields
            }
        }
    }
`;

export const QUERY_DAILY_MEETING_DSP_TOP = gql`
    ${metricScoreFields}
    query QueryDailyMeetingDspTop($statDate: String!, $warehouseId: Long!) {
        queryDailyMeetingDspTop(statDate: $statDate, warehouseId: $warehouseId) {
            dspId
            dspName
            actualArrivals
            totalScore
            metrics {
                ...DailyMeetingMetricScoreFields
            }
        }
    }
`;

export const QUERY_DAILY_MEETING_TREND = gql`
    ${metricScoreFields}
    query QueryDailyMeetingTrend($warehouseId: Long!, $endDate: String!) {
        queryDailyMeetingTrend(warehouseId: $warehouseId, endDate: $endDate) {
            statDate
            totalScore
            light
            actualArrivals
            metrics {
                ...DailyMeetingMetricScoreFields
            }
        }
    }
`;

export const LOAD_DAILY_MEETING_ATTRIBUTIONS = gql`
    query LoadDailyMeetingAttributions($statDate: String!, $warehouseIds: [Long!]!) {
        loadDailyMeetingAttributions(statDate: $statDate, warehouseIds: $warehouseIds) {
            id
            warehouseId
            statDate
            reason
            notes
            expectedRecoveryDate
            claimStatus
            claimerId
            claimerName
            creatorId
            creatorName
            updatedById
            updatedByName
            createdAt
            updatedAt
        }
    }
`;
